import { Modal, ModalProps } from '@mui/material';
import { useDispatch } from 'react-redux';
import { actions as FormErrorActions } from 'app/containers/Dashboard/FormError/slice';

export function FormWrapperModal(props: ModalProps) {
  const dispatch = useDispatch();
  return (
    <Modal
      {...props}
      onClose={(event, reason) => {
        if (props.onClose) {
          props.onClose(event, reason);
        }
        dispatch(FormErrorActions.close());
      }}
    >
      {props.children}
    </Modal>
  );
}
